import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropdownOptions } from "../components/common/Dropdown/Dropdown";
import { getClients } from "../services/transactionService";
import { setClientDetails } from "../redux/features/clientDetailsSlice";
import { generateClientName } from "../utils/utils";

export const useClientDetails = () => {
  const { clientDetails } = useSelector((state: any) => state.clientDetails);

  const [clientOptions, setClientOptions] = useState<DropdownOptions[]>([]);
  const dispatch = useDispatch();

  const getClientOptions = async () => {
    if (clientDetails.length > 0) {
      setClientOptions(clientDetails);
    } else {
      getClients()
        ?.then((res) => {
          const clients: DropdownOptions[] = [];
          res.forEach((client: any) => {
            if (client.isActive) {
              clients.push({
                value: client.id,
                label: generateClientName(client),
              });
            }
          });
          dispatch(setClientDetails(clients));
          setClientOptions(clients);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    getClientOptions();
  }, []);

  return { clientOptions };
};
